import {Component, Input, OnInit} from '@angular/core';
import {OrderModel} from '../../dashboard/monitoring/order.model';
import {RouteLibraryService} from '../../route/route-library.service';
import {UnitImagesShort} from '../../dashboard/monitoring/unit';
import {EndUserImage} from '../../end-user/models/end-user.model';
import {RouteLibraryEntities} from '../../route/route-library-entity';

@Component({
  selector: 'app-unit-last-order',
  templateUrl: './unit-last-order.component.html',
})
export class UnitLastOrderComponent implements OnInit {
  protected readonly RouteLibraryEntities = RouteLibraryEntities;
  @Input() lastFinishedOrCancelledOrder: OrderModel = null;
  imagesShort: Array<UnitImagesShort> = [];
  imageSrc: EndUserImage;

  constructor(
    public routeLibrary: RouteLibraryService,
  ) {
  }

  ngOnInit() {
    if (this.lastFinishedOrCancelledOrder
      && this.lastFinishedOrCancelledOrder.unitImagesShort
      && this.lastFinishedOrCancelledOrder.unitImagesShort.length > 0
    ) {
      this.imagesShort = this.lastFinishedOrCancelledOrder.unitImagesShort;
    } else {
      this.imageSrc = {
        image: 'assets/img/no-image.svg',
        title: 'No order finish photo',
      };
    }
  }
}

